__turbopack_context__.v({
  "activeTabBorder": "jY_7lq_activeTabBorder",
  "centeredTab": "jY_7lq_centeredTab",
  "tabHeader": "jY_7lq_tabHeader",
  "tabHeadlineButton": "jY_7lq_tabHeadlineButton",
  "tabHeadlineText": "jY_7lq_tabHeadlineText",
});
